var SwiperCarousel;
(function (SwiperCarousel) {
    let __flyerSwiper; 
    function initPromoSwiper($scope) {
        const $swiperEl = $scope.querySelector('.flyer-swiper');
        const $prevBtn = $scope.querySelector('.flyer-prev');
        const $nextBtn = $scope.querySelector('.flyer-next');
        const $pagin = $scope.querySelector('.flyer-pagination');
        if (!($swiperEl && $prevBtn && $nextBtn && $pagin))
            return;
        if (__flyerSwiper && __flyerSwiper.destroy) {
            __flyerSwiper.destroy(true, true);
            __flyerSwiper = null;
        }
        __flyerSwiper = new Swiper($swiperEl, {
            slidesPerView: 3,
            spaceBetween: 24,
            loop: false,
            watchOverflow: true,
            grabCursor: true,
            pagination: { el: $pagin, clickable: true },
            navigation: { nextEl: $nextBtn, prevEl: $prevBtn },
            breakpoints: {
                0: { slidesPerView: 1.5, spaceBetween: 16 },
                640: { slidesPerView: 2, spaceBetween: 20 },
                992: { slidesPerView: 3, spaceBetween: 24 } 
            },
            observer: true,
            observeParents: true,
            updateOnWindowResize: true
        });
    }
    document.addEventListener('init-swiper-carousel', data => {
        const $carousel = data.target.querySelector(".flyer-wrap");
        initPromoSwiper($carousel);
    });
})(SwiperCarousel || (SwiperCarousel = {}));
